import discountCouponTypes from '@/util/discountCouponTypes'

export default {
  couponTypeOptions () {
    return Object.keys(discountCouponTypes).map(key => {
      return {
        label: discountCouponTypes[key],
        value: parseInt(key),
      }
    })
  },
}
